import {
  updateCliente,
  saveRequestFromUrl
} from '../endpoints/crm';

export class CrmAPI implements CrmAPI {

  saveRequestFromUrl(formData:any){
    return saveRequestFromUrl(formData)
  }


  updateCliente(formData:any){
    return updateCliente(formData)
  }
}